module.exports = __webpack_public_path__ + "media/images/officebooking-e1006cd8.svg";